<template>
  <div class="container" ref="questionsRef">
    <div class="row flex-column justify-content-center align-items-center">
      <div class="col-lg-12 question-wrapper" v-for="(question, idx) in questions" :key="idx">
        <div v-if="question.type == 'checkbox'">
          <div class="question" v-html="$t(question.text)"></div>
          <div class="subQuestion" v-html="$t(question.subText)"></div>
          <div class="inputWrapper" role="group">
            <div
              class="radio-input"
              v-for="(option, i) in question.options"
              :key="option.name"
              :class="questionModel[idx].indexOf(option) != -1 ? 'active' : ''"
            >
            <label class="box-container w-100" :for="`checkbox-group-${idx}-${i}`">
              <input
                v-model="questionModel[idx]"
                type="checkbox"
                :id="`checkbox-group-${idx}-${i}`"
                :name="`checkbox-group-${idx}`"
                :value="option"
                autocomplete="off"
                checked
                @change="updateCheckbox(idx)"
              >
              <span class="checkmark"></span>
              {{$t(option)}}
            </label>
            </div>
          </div>
          <input v-if="question.otherOption" class="input" :class="otherModelDisabled[idx] ? 'hide' : 'show'" :disabled="otherModelDisabled[idx]" :name="`checkbox-group-${idx}`" type="text" :placeholder="question.otherText" aria-label="Other option" value="" v-model="otherModel[idx]" @change="otherModelSelected(idx)">
        </div>
        <div v-else-if="question.type=='radio'">
          <div class="question" v-html="$t(question.text)"></div>
          <div class="subQuestion" v-html="$t(question.subText)"></div>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio-group
              :id="`radio-group-${idx}`"
              :name="`radio-group-${idx}`"
              v-model="questionModel[idx]"
              :options="question.options"
              :aria-describedby="ariaDescribedby"
              stacked
              size="lg"
              ></b-form-radio-group>
            </b-form-group>
        </div>
        <div v-else-if="question.type=='textarea'">
          <div class="question" v-html="$t(question.text)"></div>
          <textarea type="text" class="w-100" v-model="questionModel[idx]" value="" :placeholder="question.placeholder"></textarea>
        </div>
      </div>
      <div v-if="this.error" class="my-5" style="font: normal normal normal 16px/20px avenir_lt_35_lightregular; color: red;">
        {{error}}
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import axios from "axios";

export default {
  name: "survey",
  components: {
  },
  props: {
    mandatory: {
      type: Boolean,
      default: false
    },
    questions: {
      type: Array,
      default: () => []
    },
    successAction: {
      type: Object,
      default: () => null
    },
    apiUrl: {
      type: String,
      default: "https://js-backend.justsnap.eu/api/survey"
    }
  },
  data () {
    return {
      questionModel: [],
      otherModel: [],
      otherModelDisabled: [],
      error: ''
    }
  },
  created () {
    for (let i = 0; i < this.questions.length; i++) {
      this.questionModel[i] = [];
      this.otherModelDisabled[i] = true;
    }
  },
  watch: {
    // questionModel (val) {
    //   console.log("value: ", val)
    // },
    // otherModel (val) {
    //   console.log("other value: ", val)
    // }
  },
  mounted () {
    this.$eventHub.$on("getSurveyData-event", this.sendSurvey);
  },
  beforeDestroy () {
    this.$eventHub.$off("getSurveyData-event", this.sendSurvey);
  },
  computed: {
    ...mapGetters(['customerToken' , 'campaignId', 'receiptToken'])
  },
  methods: {
    ...mapActions(['sendSurveyData']),
    updateCheckbox (idx) {
      if (this.questions[idx].otherOption) {
        if (this.questionModel[idx].indexOf('Other') != -1) {
          this.otherModelDisabled[idx] = false
        } else {
          // console.log("other", this.questionModel[idx])
          let i = this.questionModel[idx].indexOf(this.otherModel[idx])
          if (i != -1) {
            this.questionModel[idx].splice(i, 1)
          }
          this.otherModel[idx] = ""
          this.otherModelDisabled[idx] = true
        }
      }
    },
    otherModelSelected (idx) {
      this.questionModel[idx].push(this.otherModel[idx]);
    },
    sendSurvey (skipSurvey) {
      if (this.mandatory) {
        if (this.questionModel.some(x => x.length == 0)) {
          this.error = this.$t('Survey is mandatory')
          return;
        }
      }
      let data = {};
      data.questions = []
      if (!skipSurvey) {
        data.questions = this.questionModel;
      }
      console.log("Data: ", data)
      // Send data to backend
      data.customerToken = this.customerToken;
      data.receiptToken = this.receiptToken;
      data.campaignId = this.campaignId;
      this.sendSurveyData( { formData: data, apiUrl: this.apiUrl }).then(res => {
        const fn = this.successAction.fn;
        const params = this.successAction.params;
        this[fn](params, this);
      }).catch(err => {
        this.$eventHub.$emit("done-event-trigger", {
          parent: this,
          status: false
        });
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.tg  {border-collapse:collapse;border-color:#C44D58;border-spacing:0;}
.tg td{background-color:#F9CDAD;border-color:#C44D58;border-style:solid;border-width:0px;color:#002b36;
  font-family:Arial, sans-serif;font-size:14px;overflow:hidden;padding:10px 5px;word-break:normal;}
.tg th{background-color:#FE4365;border-color:#C44D58;border-style:solid;border-width:0px;color:#fdf6e3;
  font-family:Arial, sans-serif;font-size:14px;font-weight:normal;overflow:hidden;padding:10px 5px;word-break:normal;}
.tg .tg-zv4m{border-color:#ffffff;text-align:left;vertical-align:top}
.tg .tg-b6o2{background-color:#FFA4A0;border-color:#ffffff;text-align:left;vertical-align:top}
</style>
<style lang="scss" scoped>

@media (max-width: 600px) {
  .tg td {
    font-size: 14px;
    padding: 1px;
  }
  .tg th {
    font-size: 14px;
    padding: 1px;
  }
}

@media (max-width: 450px) {
  table {
    position: relative;
    left: -1rem;
  }
  .tg td {
    font-size: 12px;
    padding: 1px;
  }
  .tg th {
    font-size: 12px;
    padding: 1px;
  }
}

.cursorPointer {
  cursor: pointer;
}

.question-wrapper {
  width: 50%;
  color: var(--text-color-2);
  @media (max-width: 991px) {
    width: 90%;
  }
}

.question {
	display: block;
	font-size: 1.2em;
	margin-top: 30px;
  margin-bottom: 20px;
	font-weight: bold;
}

.subQuestion {
  font-size: 12px;
  line-height: 15px;
  font-style: italic;
  margin-bottom: 20px;
}

.surveyBtnWrapper {
  display: flex;
  justify-content: center;
}

.survey-btn {
	background-color: rgb(255, 255, 255);
	border-radius: 8px;
	max-width: 410px;
	min-height: 60px;
	border-color: rgb(27, 87, 142);
	margin-bottom: 130px;
	margin-top: 30px;
  color: #1B578E;
  font-size: 22px;
  font-family: 'Neue Frutiger World';
}
.survey-btn:disabled {
  opacity: 0.65;
}

.inputWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  div {
    width: 100%;
    border: 1px solid var(--input-border-color);
    border-radius: 8px;
    margin-bottom: 5px;
  }
  // div:nth-child(odd) {
  //   border-right: none;
  //   border-top-right-radius: 0;
  //   border-bottom-right-radius: 0;
  // }
  // div:nth-child(even) {
  //   border-right: none;
  //   border-top-left-radius: 0;
  //   border-bottom-left-radius: 0;
  // }
}
/* The container */
.box-container {
  display: block;
  position: relative;
  padding: 5px 35px;
  cursor: pointer;
  font-size: 16px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.box-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 35%;
  left: 10px;
  height: 15px;
  width: 15px;
  background-color: transparent;
  border: 1px solid var(--input-border-color);
  border-radius: 50%;
  margin-bottom: 0 !important;
}

// /* On mouse-over, add a grey background color */
// .box-container:hover input ~ .checkmark {
//   background-color: #ccc;
// }

/* When the radio button is checked, add a blue background */
.box-container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.box-container input:checked ~ .checkmark:after {
  display: none;
}

/* Style the indicator (dot/circle) */
.box-container .checkmark:after {
  top: 9px;
	left: 9px;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: white;
}

.active {
  background-color: var(--input-border-color);
}

.hide {
  display: none;
}

.show {
  display: block;
}

.input {
	background: #FFFFFF;
	border: 1px solid #D1E7FF !important;
	box-sizing: border-box;
	border-radius: 8px;
	transition: border-color 0.15s;
	height: 40px;
  width: 100%;
}

</style>